<template>
  <div class="combo-available">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong class="first">
                <h3>
                  <router-link :to="{ name: 'combo_list'}" class="float-left mr-1 main-link">{{$t('combo.combos')}}</router-link>
                  <span class="float-left mr-1 main-link">/</span>
                  <router-link :to="{ name: 'combo_edit',  params: { uuid: uuid }}" class="float-left mr-1 main-link">{{$t('combo.detail')}}</router-link>
                  / {{$t('menu.day_part')}}
                </h3>
              </strong>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-card header-tag="header" footer-tag="footer" body-class="p-3" v-if="combo.config.opening_hours || combo.config.special_date">
        <div slot="header">
          <strong class="uppercase">{{ $t('menu.day_part') }}</strong>
        </div>
        <b-row>
          <!-- Part of Days of Week -->
          <b-col cols="4" v-if="combo.config.opening_hours && dataDayPart">
            <b-form-group :label-cols="3" :horizontal="true" v-for="dayPart in dataDayPart" :key="dayPart.day" v-bind:label="$t('common.'+dayPart.day)">
              <div role="group" class="input-group">
                <a href="javascript:void(0)" class="reset-custom" @click="resetTime(dayPart)">
                  {{ $t('banner.reset') }}
                </a>
                <div class="input-group-append">
                  <div class="input-group-text">
                    <b-form-checkbox v-model="dayPart.active" :value="1" :unchecked-value="0"></b-form-checkbox>
                  </div>
                </div>
                <!--<masked-input
                  type="text"
                  name="date"
                  class="form-control col-sm-6 float-left"
                  v-model="opening_times[day].opening"
                  :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                  :guide="true"
                  placeholderChar="_"
                  :showMask="true"
                  :keepCharPositions="true">
                </masked-input>-->
                <date-picker-input
                  className="form-control col-sm-6 float-left"
                  name="date"
                  type="time"
                  v-model="dayPart.opening"
                  :lang="$session.get('lang')"
                  :hasPicker="true"
                  formatInput="HH:mm:ss"
                  formatOutput="HH:mm:ss"
                  :change="(e) => dayPart.opening = e"
                />
                <div class="input-group-append">
                  <div class="input-group-text"><i class="fa fa-minus"></i></div>
                </div>
                <!--<masked-input
                  type="text"
                  name="date"
                  class="form-control col-sm-6 float-left"
                  v-model="opening_times[day].closing"
                  :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                  :guide="true"
                  placeholderChar="_"
                  :showMask="true"
                  :keepCharPositions="true">
                </masked-input>-->
                <date-picker-input
                  className="form-control col-sm-6 float-left"
                  name="date"
                  type="time"
                  v-model="dayPart.closing"
                  :lang="$session.get('lang')"
                  :hasPicker="true"
                  formatInput="HH:mm:ss"
                  formatOutput="HH:mm:ss"
                  :change="(e) => dayPart.closing = e"
                />
              </div>
            </b-form-group>
          </b-col>
          <!-- End of Days of Week -->

          <!-- Part of Special Date -->
          <b-col cols="8" v-if="combo.config.special_date">
            <b-form-group :label-cols="11" v-bind:label="$t('menu.exception_date')">
              <table class="table table-bordered table-hover">
                <thead>
                <tr>
                  <th class="hide">{{$t('menu.exception_table_name')}}</th>
                  <th>{{$t('menu.exception_table_date')}}</th>
                  <th>{{$t('menu.exception_table_time')}}</th>
                  <th>{{$t('combo.open')}}</th>
                  <th>{{$t('common.action')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(date, index) in special_dates" :key="date.id">
                  <td class="hide">
                    <b-form-input class="form-control" v-model="special_dates[index].name">
                    </b-form-input>
                  </td>
                  <td>
                    <!--<masked-input
                      type="text"
                      name="date"
                      class="form-control"
                      v-model="special_dates[index].date"
                      :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                      :guide="true"
                      placeholderChar="_"
                      :showMask="true"
                      :keepCharPositions="true">
                    </masked-input>-->
                    <date-picker-input
                      className="form-control col-sm-6 float-left"
                      name="date"
                      type="date"
                      v-model="special_dates[index].date"
                      :lang="$session.get('lang')"
                      :hasPicker="true"
                      formatInput="DD-MM-YYYY"
                      formatOutput="DD-MM-YYYY"
                      :change="(e) => special_dates[index].date = e"
                    />
                  </td>
                  <td>
                    <div role="group" class="input-group">
                      <!--<masked-input
                        type="text"
                        name="date"
                        class="form-control col-sm-6 float-left"
                        v-model="special_dates[index].from"
                        :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                        :guide="true"
                        placeholderChar="_"
                        :showMask="true"
                        :keepCharPositions="true">
                      </masked-input>-->
                      <date-picker-input
                        className="form-control col-sm-6 float-left"
                        name="date"
                        type="time"
                        v-model="special_dates[index].from"
                        :lang="$session.get('lang')"
                        :hasPicker="true"
                        formatInput="HH:mm:ss"
                        formatOutput="HH:mm:ss"
                        :change="(e) => special_dates[index].from = e"
                      />
                      <div class="input-group-append">
                        <div class="input-group-text"><i class="fa fa-minus"></i></div>
                      </div>
                      <!--<masked-input
                        type="text"
                        name="date"
                        class="form-control col-sm-6 float-left"
                        v-model="special_dates[index].to"
                        :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                        :guide="true"
                        placeholderChar="_"
                        :showMask="true"
                        :keepCharPositions="true">
                      </masked-input>-->
                      <date-picker-input
                        className="form-control col-sm-6 float-left"
                        name="date"
                        type="time"
                        v-model="special_dates[index].to"
                        :lang="$session.get('lang')"
                        :hasPicker="true"
                        formatInput="HH:mm:ss"
                        formatOutput="HH:mm:ss"
                        :change="(e) => special_dates[index].to = e"
                      />
                    </div>
                  </td>
                  <td>
                    <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="special_dates[index].status" :checked="special_dates[index].status" :value="1" :uncheckedValue="0"/>
                  </td>
                  <td>
                    <b-button class="btn btn-transparent text-main border-radius-4px delete-date" v-on:click="removeSpecialDate(index)" size="sm"><i class="fa fa-trash-o"></i></b-button>
                  </td>
                </tr>
                <tr>
                  <td colspan="6">
                    <button type="button" class="btn bg-main border-radius-4px" v-on:click="addSpecialDate"><i class="fa fa-plus"></i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-form-group>
          </b-col>
          <!-- End of Special Date -->
        </b-row>

        <div slot="footer">
          <button type="button" class="btn border-radius-4px bg-main float-left ml-4" @click="$router.back()"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
          <div class="btn-save">
            <button class="btn bg-main border-radius-4px btn-main pl-3 pr-3" v-on:click="saveItem()" v-if="!processing">{{$t('common.save')}}</button>
          </div>
        </div>
      </b-card>
    </div>

  </div>
</template>
<style>
  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #0091ff !important;
  }
</style>
<style scoped>
  .delete-date {
    font-size: 18px;
    font-weight: bold;
  }
  .combo-available .switch.switch-icon{
    margin-top: 5px;
  }

  .reset-custom {
    margin-right: 10px;
    margin-top: 7px;
    color: #0091FF !important;
  }

  .combo-available .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .combo-available .header-custom-switch .col-form-label{
    text-align: right;
  }

  .combo-available .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .combo-available .header-custom-switch .uppercase .first{
    margin-right: 10px;
  }

  .combo-available .header-custom-switch .uppercase .last{
    margin-left: 10px;
  }

  .combo-available .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .combo-available .btn-save{
    float: right;
    margin-right: 22px;
  }
  .btn-circle {
    border: 1px solid #0091ff;
    border-radius: 50%;
    color: #0091ff;
    width: 15px;
    height: 15px;
    text-align: center;
  }
  .close-btn {
    font-size: 18px;
    cursor: pointer;
    float: right;
    line-height: 18px;
    margin-left: 10px;
    color: #2a2c36;
  }
  .close-btn .fa-angle-right {
    margin-right: -4px;
  }
  .close-btn .fa-angle-left {
    margin-left: -4px;
  }
  .combo-available .card,
  .combo-available .card header.card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  .combo-available .card .card-body {
    padding-top: 0px;
  }
  .topping-search {
    width: 100%;
    display: flex;
    background: #e1e6eb;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding: 20px;
  }
  .topping-label {
    width: auto;
    padding-right: 20px;
    line-height: 35px;
    font-weight: 600;
  }
  .topping-input {
    flex: 1;
  }
  .topping-input .input-group-text {
    background: #fff !important;
    border-right: none !important;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .topping-input input {
    border-left: none !important;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .selected-topping {
    background: #82909b;
    padding: 7px 10px;
    border-radius: 30px;
    margin-right: 15px;
    color: #fff;
    margin-top: 10px;
    float: left;
  }
  .selected-topping.special {
    background: #1cdd6e;
  }
  .topping-list {
    width: 100%;
    padding: 20px;
    background: #f5f7f9;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    margin-bottom: 20px;
  }
  .topping-item {
    padding: 5px 15px;
    cursor: pointer;
  }
  .topping-list span {
    border-radius: 20px;
    padding: 2px 10px 2px 5px;
  }
  .topping-list span.special {
    background-color: #1cdd6e;
  }
</style>
<script>
import cSwitch from '../../../components/Switch'
import MaskedInput from 'vue-text-mask'
import DatePickerInput from '@/components/Partials/DatePickerInput'

let vm = null

export default {
  name: 'MenuAvailable',
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  components: {
    cSwitch,
    MaskedInput,
    DatePickerInput
  },
  data: function () {
    return {
      daysOfWeek: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'pub'],
      combo: this.$store.getters.config.gms.combo,
      special_dates: [],
      opening_times: {},
      processing: false,
      dataDayPart: []
    }
  },
  methods: {
    /**
     * remove special date from list
     * @param index
     */
    removeSpecialDate (index) {
      let dates = []

      for (let i in this.special_dates) {
        if (i != index) {
          dates.push(this.special_dates[i])
        }
      }

      this.special_dates = dates
    },
    resetTime(dayPart) {
      dayPart.opening = '00:00:00'
      dayPart.closing = '23:59:59'
    },
    /**
     * add special date to list with default attribute
     */
    addSpecialDate () {
      this.special_dates.push({
        name: '',
        from: '00:00:00',
        to: '23:59:59',
        date: this.$moment().format('DD-MM-YYYY'),
        status: 1,
        active: 1
      })
    },/**
     * convert data format then update item, then back to list page
     */
    saveItem () {
      let special_dates = JSON.parse(JSON.stringify(vm.special_dates))
      for(let i of special_dates){
        i.date = vm.revertDateFormat(i.date)
      }
      for (let i = 0; i < vm.dataDayPart.length; i++) {
        const element = vm.dataDayPart[i];
        vm.opening_times[element.day].opening = element.opening
        vm.opening_times[element.day].closing = element.closing
        vm.opening_times[element.day].active = element.active
      }
      let item = {
        uuid: vm.uuid,
        product_type: "combo",
        opening_times: vm.opening_times,
        special_dates: special_dates
      }
      // call an API to save menu information
      vm.processing = true

      vm.axios.updateDayPart(item, function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        let openingTime = {}
        for(let i of response.data.data.opening_times){
          openingTime[i.day] = {
            day: i.day,
            opening: i.opening,
            closing: i.closing,
            active: i.active
          }
        }
        vm.opening_times = openingTime
        for(let i of  response.data.data.special_dates){
          i.date = vm.convertDateFormat(i.date)
        }
        vm.special_dates = response.data.data.special_dates
        vm._.cloneDeep(vm.opening_times)
        vm.processing = false
      }, function () {
        vm.processing = false
      })
      // this._.cloneDeep(vm.item)
    },
    /**
     * convert date from YYYY-MM-DD to DD-MM-YYYY
     * @param val
     * @returns {*}
     */
    convertDateFormat (val) {
      // val = this.convertUTCToClientTime(val)
      return this.$moment(val, 'YYYY-MM-DD').format('DD-MM-YYYY')
    },
    /**
     * revert date from DD-MM-YYYY to YYYY-MM-DD
     * @param val
     * @returns {*}
     */
    revertDateFormat (val) {
      let formatDate = this.$moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD')
      return formatDate
    },
  },
  created: function () {
    vm = this
    for (let i in vm.daysOfWeek) {
      vm.opening_times[vm.daysOfWeek[i]] = {
        day: vm.daysOfWeek[i],
        opening: '00:00:00',
        closing: '23:59:59',
        active: 1
      }
      vm.dataDayPart.push({
        day: vm.daysOfWeek[i],
        opening: '00:00:00',
        closing: '23:59:59',
        active: 1
      })
    }
    

    vm.axios.getDayPart({uuid: vm.uuid}, function (response) {
      if (response.data.data.opening_times != null && response.data.data.opening_times.length > 0) {
        let openTimes = vm.opening_times
        for (let i in response.data.data.opening_times) {
          openTimes[response.data.data.opening_times[i].day] = {
            day: response.data.data.opening_times[i].day,
            opening: response.data.data.opening_times[i].opening,
            closing: response.data.data.opening_times[i].closing,
            active: response.data.data.opening_times[i].active
          }
        }
        vm.opening_times = openTimes
      }

      for (let i = 0; i < vm.dataDayPart.length; i++) {
        vm.dataDayPart[i].active = vm.opening_times[vm.dataDayPart[i].day].active
        vm.dataDayPart[i].opening = vm.opening_times[vm.dataDayPart[i].day].opening
        vm.dataDayPart[i].closing = vm.opening_times[vm.dataDayPart[i].day].closing
      }

      if (response.data.data.special_dates == null) {
        vm.special_dates = []
      } else {
        let special_dates = vm._.cloneDeep(response.data.data.special_dates)
        for (let i in special_dates) {
          special_dates[i].date = vm.convertDateFormat(special_dates[i].date)
        }

        vm.special_dates = special_dates
      }
    })
  },
  mounted: function () {
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/combo/AvailableForm.vue